<template>
  <Box>
    <form class="dialog" onsubmit="return false">
      <div class="header has-bcc-background has-text-white">
        <span>Client Uploads</span>
      </div>

      <div class="body">
        <form @submit.prevent="submitFiles">
          <div style="display: block; height: auto; max-height: 420px; overflow-x: auto">
            <FilePond
              name="file"
              ref="pond"
              label-idle="<div><span class='icon' style='padding-top:20px; font-size: 3rem;'><i class='fas fa-3x fa-cloud-upload-alt'></i></span></div><div>Click here or drop one or more files here to upload</div>"
              allow-multiple="true"
              accepted-file-types="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel"
              :files="files"
              @removefile="removeFiles"
              @addfilestart="addfile"
              :dropOnElement="false"
              :dropOnPage="true"
              :instantUpload="false"
              :allowRevert="false"
              :allowProcess="false"
              :credits="[]"
              @click.stop=""
              :server="{
                instantUpload: false,
                url,
                process: {
                  url: `/documents/clients`,
                  method: 'POST',
                  withCredentials: true,
                  instantUpload: false,
                  onload: (response) => {
                    let r = JSON.parse(response)
                    uploadedFiles.push(r)
                    return r.id
                  },
                  ondata(payload) {
                    payload.append('YearOverride', new Date().getFullYear())
                    return payload
                  },
                  onerror: (response) => {
                    let res = JSON.parse(response)
                    let msg = `Upload Error: ${res.message}`
                    errorToast(msg)
                  },
                },
                revert: (uniqueFileId, load, error) => {
                  let path = `/documents/clients/${uniqueFileId}`
                  axios
                    .delete(path)
                    .then((res) => {
                      load()
                    })
                    .catch((err) => {
                      error(err)
                    })
                },
                fetch: null,
                restore: null,
                load: null,
              }"
            />
          </div>

          <div class="actions">
            <button class="button has-bcc-background has-text-white" type="submit" :disabled="!files.length || isSaving">
              <spin-loader v-if="isSaving" />
              <span v-else>Upload Files</span>
            </button>
            &nbsp;&nbsp;
            <button type="button" class="button" style="margin-right: 10px" @click="() => closeDialog(null)" :disabled="isSaving">Cancel</button>
          </div>
        </form>
      </div>
    </form>
  </Box>
</template>

<script setup>
import { ref } from 'vue'
import Box from './Box.vue'
import { closeDialog } from 'vue3-promise-dialog'
import axios from '../../axios'
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import { useGlobalUtils } from '../../helpers/globalUtils'
import { computed } from 'vue'

const FilePond = vueFilePond(FilePondPluginFileValidateType)

const { errorToast, successToast } = useGlobalUtils()

const pond = ref(null)
const files = ref([])
const isSaving = ref(false)
const uploadedFiles = ref([])
const documents = ref([])

const url = computed(() => {
  return `${process.env.VUE_APP_API_URL}`
})

function addfile(file) {
  if (file.filename.length > 100) {
    errorToast(`The filename ${file.filename} is too long.<br/>Please limit the filename to 100 characters or less.`)
    pond.value.removeFile(file, {})
    return false
  }

  pond.value.getFiles().forEach(function (current) {
    if (current.id !== file.id && current.file.name === file.file.name) {
      pond.value.removeFile(current, {})
    }
  })

  files.value = pond.value.getFiles()
}

function removeFiles(error, file) {
  // Just update the files array to match the current pond state
  files.value = pond.value.getFiles()
}

async function submitFiles() {
  isSaving.value = true

  let payload = new FormData()
  payload.append('file', {})
  payload.append('YearOverride', new Date().getFullYear())
  payload.append('UploadDate', new Date().toUTCString())
  files.value.forEach((file) => {
    payload.append('file', file)
  })

  pond.value.processFiles().then(() => {
    isSaving.value = false

    pond.value.getFiles().forEach(function (current) {
      documents.value.push({
        ...current,
        displayName: current.file.name,
        fileSize: current.fileSize,
        extension: current.fileExtension,
      })
      pond.value.removeFile(current, {})
    })

    axios.post('/documents/clients/notify-clients', {
      DocumentIds: uploadedFiles.value.map((_file) => {
        return _file.id
      }),
    })

    uploadedFiles.value = []
    files.value = []

    successToast('Files uploaded successfully')
    closeDialog(true)
  })
}
</script>

<style scoped lang="scss">
@import './dialog.scss';

.dialog {
  width: 600px;
  max-width: 90vw;
  min-width: 300px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

.filepond--credits {
  display: none !important;
}
</style>
